import { Root } from '@radix-ui/react-portal';

export const Portal = Root;
